
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.167 14a5.833 5.833 0 100-11.667 5.833 5.833 0 000 11.667zM13.292 12.292l3.375 3.375","stroke":"#AAA0D4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    